/**
 * Maps the errors a passkey flow can throw — WebAuthn DOMExceptions from the
 * browser and axios errors from our endpoints — to user-facing messages.
 */
import axios from 'axios';

export function getPasskeyErrorMessage(error: unknown): string {
  // WebAuthn browser errors surface as DOMException with a meaningful `name`.
  if (error instanceof DOMException || (error instanceof Error && error.name)) {
    switch (error.name) {
      case 'NotAllowedError':
        // User dismissed the prompt or it timed out.
        return 'Passkey prompt was cancelled or timed out. Please try again.';
      case 'InvalidStateError':
        return 'This device already has a passkey for your account.';
      case 'SecurityError':
        return "Passkeys aren't available on this connection. Make sure you're on the correct, secure (https) site.";
      case 'AbortError':
        return 'Passkey request was cancelled.';
    }
  }

  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401) return 'That passkey was not recognized. Try another sign-in method.';
    const detail = (error.response?.data as { detail?: string } | undefined)?.detail;
    if (detail) return detail;
    return error.message;
  }

  if (error instanceof Error) return error.message;
  return 'Something went wrong with the passkey. Please try again.';
}
